import Carousels from './../components/Carousels';

export default class Lazyload {

	constructor() {
		this.instance = self;
		this.gridBreakpoints = {
			xxs: 0,
			xs: 350,
			sm: 576,
			md: 768,
			lg: 992,
			xl: 1200,
			xxl: 1500,
		};
	}

	static init() {
		const self = new Lazyload;
		self.attachEvents();
	}

	static watchNewElement(selector) {
		const self = new Lazyload;
		self.watchElement(selector);
	}

	attachEvents() {
    	const self = this;

    	self.watchElement('[data-lazy-img]');
		self.watchElement('[data-lazy-svg]');
		self.watchElement('[data-lazy-media-svg]');
		self.watchElement('[data-lazy-request]');
		self.watchElement('.js-carousel-lazy');
		self.watchElement('[data-lazy-count-to]', {threshold: 0.2});
		/*self.watchElement('[data-lazy-fade-in]', {threshold: 0.1});
		self.watchElement('[data-lazy-fade-in-stagger]', {threshold: 0.1});*/

		$(document).on('keydown', function(e) {
			if (e.key == 'p' && e.metaKey == true) {
				e.cancelBubble = true;
				e.preventDefault();
				e.stopImmediatePropagation();

				self.printPageLazy();
			}

			if(e.ctrlKey && (e.key == "p" || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80) ){
				e.cancelBubble = true;
				e.preventDefault();
				e.stopImmediatePropagation();

				self.printPageLazy();
			}
		});

		$(document).on('click', '.js-print', function(e) {
			e.preventDefault();
			self.printPageLazy();
		});

		window.site.lazyLoad = function(selector) {
			self.watchElement(selector);
		}

		window.site.printPageLazy = function(){
			self.printPageLazy();
		}
    }

    watchElement(selector, customConfig) {
    	const self = this;

    	let elements = document.querySelectorAll(selector),
			defaultConfig = {
				rootMargin: '50px 0px',
				threshold: 0.01
			},
			config = Object.assign(defaultConfig, customConfig);

		if (!('IntersectionObserver' in window)) {
			var elementsArray = [];

			for (var i = 0; i < elements.length; i++) {
			    elementsArray.push(elements[i]);
			}

			elementsArray.forEach(function(element) {
				self.preloadElement(element);
			});
		} else {
			var observer = new IntersectionObserver(function(entries){
				entries.forEach(function(entry){
					// Are we in viewport?
					if (entry.isIntersecting === true || entry.intersectionRatio > 0) {

						// Stop watching and load the element
						observer.unobserve(entry.target);
						self.preloadElement(entry.target);
					}
				});
			}, config);

			elements.forEach(function(element) {
				observer.observe(element);
			});
		}
    }

    printPageLazy() {
    	const self = this;

		oc.progressBar.show();

		var images = document.querySelectorAll('[data-lazy-img]'),
			imagesArray = [];

		for (var i = 0; i < images.length; i++) {
		    imagesArray.push(images[i]);
		}

		imagesArray.forEach(function(image) {
			self.preloadImage(image);
		});

		document.querySelectorAll('.js-carousel-lazy').forEach(function(carousel) {
			self.preloadCarousel(carousel);
		});

		$('.js-tab-link[href="#tabs-location"]').trigger('click');

		setTimeout(function(){
			$('body').imagesLoaded({ background: true }, function () {
				oc.progressBar.hide();
				window.print();
			});
		}, 100);
	}

	preloadElement(element) {
		const self = this;

		if (element.hasAttribute("data-lazy-img")) {
			self.preloadImage(element);
		} else if (element.hasAttribute("data-lazy-svg")) {
			self.preloadSvg(element);
		} else if (element.hasAttribute("data-lazy-media-svg")) {
			self.preloadMediaSvg(element);
		} else if (element.hasAttribute("data-lazy-request")) {
			self.preloadOcRequest(element);
		} else if (element.hasAttribute("data-lazy-count-to")) {
			self.countToElement(element);
		} else if(element.className.indexOf("js-carousel-lazy") >= 0) {
			self.preloadCarousel(element);
		} else if (element.hasAttribute("data-lazy-fade-in")) {
			self.fadeInElement(element);
		} else if (element.hasAttribute("data-lazy-fade-in-stagger")) {
			self.fadeInStaggerElement(element);
		}
	}

	preloadImage(image) {
		var elementName = image.tagName.toLowerCase(),
			imgSrc = image.getAttribute('data-lazy-img');

		if (elementName == 'img') {
			image.src = imgSrc;
		} else {
			image.style.backgroundImage = 'url(' + imgSrc + ')';
		}
	}

	preloadSvg(svg) {
		var svgFile = svg.getAttribute('data-lazy-svg'),
			url = window.site.themeDir + '/assets/svgs/' + svgFile + '.svg';

		var ajax = new XMLHttpRequest();
	    ajax.open("GET", url, true);
	    ajax.send();

	    ajax.onload = function(e) {
			svg.innerHTML = ajax.responseText;
		}
	}

	preloadMediaSvg(svg) {
		var svgFile = svg.getAttribute('data-lazy-media-svg'),
			url = '/storage/app/media' + svgFile;

		var ajax = new XMLHttpRequest();
	    ajax.open("GET", url, true);
	    ajax.send();

	    ajax.onload = function(e) {
			svg.innerHTML = ajax.responseText;
		}
	}

	preloadOcRequest(element)
	{
		const self = this;

		var request = element.getAttribute('data-lazy-request'),
			data = element.getAttribute('data-request-data') ? JSON.parse(element.getAttribute('data-request-data')) : {},
			update = JSON.parse(element.getAttribute('data-request-update')),
			successScript = element.getAttribute('data-lazy-success-script');


		oc.ajax(request, {
	        data: data,
	        update: update,
	        success: function(data, textStatus, jqXHR) {
	            this.success(data, textStatus, jqXHR);

	            $.each(update, function(partial, el) {
					$('[data-toggle="tooltip"]').tooltip();

					if ($(el + ' .js-carousel').length > 0) {
					    Carousels.initCarousel($(el +' .js-carousel'));
					}

					if ($(el + ' [data-lazy-img]').length > 0) {
						self.watchElement('[data-lazy-img]');
		            }

		            if ($(el + ' [data-lazy-media-svg]').length > 0) {
						self.watchElement('[data-lazy-media-svg]');
		            }

		            if ($(el + ' [data-lazy-svg]').length > 0) {
						self.watchElement('[data-lazy-svg]');
		            }

		            if (successScript) {
		            	eval(successScript);
		            }
	            });
	        }
	    });
	}

	countToElement(element) {
		const self = this;

		let $element = $(element),
			end = $element.data('lazy-count-to');

		$element.countTo({
			from: 0,
			to: end,
			speed: 2000
		});
	}

	preloadCarousel(element) {
		let $carousel = $(element);

		if ($carousel.hasClass('slick-initialized')) {
			return;
		}

		if ($carousel.hasClass('js-tiles-carousel')) {
			Carousels.initTilesCarousel($carousel);
		} else {
			Carousels.initCarousel($carousel);
		}
	}

	fadeInElement(element) {
		const self = this;

		$(element).addClass('is-animated-in');
	}

	fadeInStaggerElement(element) {
		const self = this;

		let $elements = $(element).find('[data-lazy-fade-in-stagger-item]'),
			timeout = 0;

		if (Modernizr.mq('(min-width: ' + self.gridBreakpoints.lg + 'px)')) {
			$elements.each(function() {
				let $element = $(this);

				setTimeout(function() {
					$element.addClass('is-animated-in');
				}, timeout);

				timeout += 250;
			});
		} else {
			$elements.each(function() {
				self.fadeInElement($(this).get()[0]);
			});
		}
	}
}
